import React from 'react';
import { cn } from '../../lib/utils';
import { MenuCategory } from '../../lib/types';
import { motion, AnimatePresence } from 'framer-motion';
interface ParentCategory {
  key: string;
  label: string;
  icon: string;
}
interface MenuParentTabsProps {
  parents: ParentCategory[];
  activeParent: string;
  onSelectParent: (parentKey: string) => void;
  subcategories: MenuCategory[];
  activeSubcategory: string;
  onSelectSubcategory: (categoryId: string) => void;
  primaryColor?: string;
  bgClassName?: string;
  isDark?: boolean;
}
export function MenuParentTabs({
  parents,
  activeParent,
  onSelectParent,
  subcategories,
  activeSubcategory,
  onSelectSubcategory,
  primaryColor = '#F59E0B',
  bgClassName,
  isDark = false
}: MenuParentTabsProps) {
  if (!parents.length) return null;
  return <div className={cn('sticky top-0 z-30 w-full backdrop-blur-md py-3 -mx-4 px-4 sm:-mx-6 sm:px-6', isDark ? 'border-b border-[#2A2420]' : 'border-b border-[#E8DDD0]', bgClassName || 'bg-[#FBF7F2]/95')} data-id="element-1377">
      {/* Level 1: Parent Tabs — scrollable text links */}
      <div className="flex gap-4 sm:gap-6 mb-3 overflow-x-auto hide-scrollbar" data-id="element-1378">
        {parents.map(parent => {
        const isActive = activeParent === parent.key;
        return <button key={parent.key} onClick={() => onSelectParent(parent.key)} className={cn('relative pb-2 text-sm font-semibold transition-colors whitespace-nowrap shrink-0 min-h-[36px] touch-manipulation', isActive ? isDark ? 'text-[#F5F0EB]' : 'text-[#3D2B1F]' : isDark ? 'text-[#8B7B6B] hover:text-[#F5F0EB]' : 'text-[#8B7355]/60 hover:text-[#3D2B1F]')} data-id="element-1379">
              {parent.label}
              {isActive && <motion.div layoutId="activeParentIndicator" className="absolute bottom-0 left-0 right-0 h-[2px] rounded-full" style={{
            backgroundColor: primaryColor
          }} initial={false} transition={{
            type: 'spring',
            stiffness: 500,
            damping: 35
          }} data-id="element-1380" />}
            </button>;
      })}
      </div>

      {/* Level 2: Subcategory Chips — subtle pills (hidden when only 1 subcategory) */}
      <AnimatePresence mode="wait" data-id="element-1381">
        {subcategories.length > 1 && <motion.div key={activeParent} initial={{
        opacity: 0,
        y: 4
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -4
      }} transition={{
        duration: 0.15
      }} className="flex overflow-x-auto hide-scrollbar" data-id="element-1382">
            <div className="flex gap-2 min-w-max" data-id="element-1383">
              {subcategories.map(category => {
            const isActive = activeSubcategory === category.id;
            return <button key={category.id} onClick={() => onSelectSubcategory(category.id)} className={cn('px-3.5 py-1.5 text-xs font-medium rounded-full transition-all whitespace-nowrap shrink-0 min-h-[32px] touch-manipulation', isActive ? isDark ? 'text-[#F5F0EB]' : 'text-[#3D2B1F]' : isDark ? 'text-[#8B7B6B] hover:text-[#F5F0EB] bg-transparent' : 'text-[#8B7355]/60 hover:text-[#3D2B1F] bg-transparent')} style={isActive ? {
              backgroundColor: `${primaryColor}20`,
              color: primaryColor
            } : {}} data-id="element-1384">
                    {category.name}
                  </button>;
          })}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}